var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { scroller } from "react-scroll";
var Accordioncommon = function (props) {
    var _a;
    var device = DeviceContext();
    var _b = __read(useState((props === null || props === void 0 ? void 0 : props.defaultActiveKey) ? props === null || props === void 0 ? void 0 : props.defaultActiveKey : ""), 2), selectedKey = _b[0], setSelectedKey = _b[1];
    var _c = __read(useState(0), 2), scrollPos = _c[0], setScrollPos = _c[1];
    var _d = __read(React.useState({ isOpen: false, errMsg: null }), 2), errMsg = _d[0], setErrMsg = _d[1];
    var _e = __read(useState(false), 2), isLoader = _e[0], setIsLoader = _e[1];
    var handleScroll = function (e) {
        var position = e.currentTarget.scrollTop;
        setScrollPos(position);
    };
    var scrollRef = useRef(null);
    var scrollToTop = function () {
        scrollRef &&
            scrollRef.current &&
            scrollRef.current.scroll({
                top: 0,
                behavior: "smooth",
            });
    };
    React.useEffect(function () {
        if (props.defaultActiveKey)
            setSelectedKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    return (React.createElement(React.Fragment, null,
        props.maintitle && React.createElement("div", null, props.maintitle),
        React.createElement(Accordion, { activeKey: selectedKey, onSelect: function (key) {
                setSelectedKey(key);
                key &&
                    ((props === null || props === void 0 ? void 0 : props.scrollToView) || props.scrollUsingRef) &&
                    setTimeout(function () {
                        var _a;
                        if (props.scrollUsingRef)
                            (_a = scrollRef === null || scrollRef === void 0 ? void 0 : scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                                behavior: "smooth",
                                block: "start",
                            });
                        else {
                            scroller.scrollTo(key === null || key === void 0 ? void 0 : key.toString(), {
                                behaviour: "smooth",
                                offset: -100,
                            });
                        }
                    }, 500);
            }, id: "accordian", className: "customaccordian customaccordian-new ".concat(props.parentClass) }, (props === null || props === void 0 ? void 0 : props.AccordionArray) &&
            ((_a = props === null || props === void 0 ? void 0 : props.AccordionArray) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            (props === null || props === void 0 ? void 0 : props.AccordionArray.map(function (accordiandata, idx) {
                return (React.createElement(Accordion.Item, { id: accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.eventKey, key: idx, eventKey: accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.eventKey, className: "".concat(props.externalClass) },
                    React.createElement(Accordion.Header, { className: "".concat(accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.eventKey), as: (props === null || props === void 0 ? void 0 : props.isLink) ? Link : undefined, to: (props === null || props === void 0 ? void 0 : props.isLink) && (accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.route)
                            ? accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.route
                            : "", onClick: function () {
                            (props === null || props === void 0 ? void 0 : props.handleTitle) &&
                                (props === null || props === void 0 ? void 0 : props.handleTitle(accordiandata.title));
                            (props === null || props === void 0 ? void 0 : props.handleeventClick) &&
                                (props === null || props === void 0 ? void 0 : props.handleeventClick(accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.eventKey));
                        } }, accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.title),
                    React.createElement(Accordion.Body, null,
                        React.createElement("div", { onScroll: handleScroll, key: idx, ref: (accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.eventKey) === selectedKey &&
                                ((accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.backToTop) || props.scrollUsingRef)
                                ? scrollRef
                                : null, id: "accordion-content", className: "".concat(props.innerClassName, " ").concat(accordiandata.backToTop && "setHeight") },
                            React.createElement("div", null,
                                scrollPos > 20 && (accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.backToTop) && (React.createElement("div", { className: "blur-on-scroll" })), accordiandata === null || accordiandata === void 0 ? void 0 :
                                accordiandata.tabContent)),
                        (accordiandata === null || accordiandata === void 0 ? void 0 : accordiandata.backToTop) && (React.createElement("div", { className: device && device.isDesktop
                                ? "DMSans_16_500 accordian-back  txt-midnight-blue align-items-center d-flex justify-content-end mt-2 hand_cursor"
                                : "DMSansMedium_12_500 accordian-back  txt-midnight-blue align-items-center d-flex justify-content-end mt-2 hand_cursor", onClick: scrollToTop },
                            React.createElement("i", { className: "edel-icon-point-arrow-up" }),
                            React.createElement("span", { className: device && device.isDesktop
                                    ? "ps-1 DMSans_16_500"
                                    : "DMSansMedium_12_500" }, "Back to top"))))));
            })))));
};
export default Accordioncommon;
